<template>
  <div>
    <h1>{{ msg }}</h1>
  </div>
</template>

<script>
import {authCode} from "@/utils/api";

export default {
  name: "WXCallback",
  data() {
    return {
      user: null,
      msg: null,
    };
  },
  async created() {
    const query = new URLSearchParams(this.$route.query);
    const code = query.get("code");
    if (code) {
      authCode({ code }).then(res=>{
          const response_code = res.Code;
          if (response_code === 0) {
            const data = res.Data;
            const token = data["access_token"];
            localStorage.setItem("token", token);
            this.msg = "登录成功";
            this.$router.push("/mobile");
          } else {
            this.msg = "登录失败";
            console.error("登录失败:", res.Msg);
          }
      }).catch(err=>{
        this.msg = "登录失败";
        console.error("登录失败:",err);
      })
    } else {
      this.$router.push("/auth"); // 重定向到首页或其他页面
    }
  },
};
</script>
